module.exports = __webpack_public_path__ + "static/media/GTBSAnimatedSmall.a4d206d9.webp";